import PropTypes from "prop-types";
import React from "react";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import profileMenuStyle from "./ProfileMenu.module.scss";
//i18n
import { useTranslation, withTranslation } from "react-i18next";
// Redux
import { Login16, Repeat16, User16 } from "@carbon/icons-react";
import Avatar, { ConfigProvider } from "react-avatar";
import { withRouter } from "react-router-dom";
import { useProfileMenu } from "./ProfileMenuHook";
import defaultAvatar from "assets/images/users/avatar-5.jpg";

const ProfileMenu = (props: any) => {
  const [translate] = useTranslation();

  const {
    handleToggerProfile,
    handleMouseLeaveAll,
    profileDrop,
    user,
    handleClickToProfile,
    handleLogout,
    // handleClickToChangePassword,
    handleGetSwitchAccountCode,
  } = useProfileMenu();

  return (
    <React.Fragment>
      <Dropdown
        isOpen={profileDrop}
        toggle={handleToggerProfile}
        className={"dxg-dropdown"}
      >
        <DropdownToggle
          className={`btn ${profileMenuStyle["button-header-profile"]}`}
          id="page-header-user-dropdown"
          tag="button"
        >
          {user?.avatar ? (
            <div>
              <div className="d-inline-block text-right p-r--xs">
                <span className="d-none d-xl-inline-block user-info-btn">
                  <strong className="d-block">{user?.username}</strong>
                  <small className="text-muted">
                    {user?.jobTitle || "N/A"}
                  </small>
                </span>
              </div>
              <img
                className="rounded-circle header-profile-user"
                src={user?.avatar ? user?.avatar : defaultAvatar}
                alt="Header Avatar"
              />
            </div>
          ) : (
            <ConfigProvider colors={["red", "green", "blue"]}>
              <Avatar
                maxInitials={1}
                round={true}
                size="22"
                name={user?.displayName}
              />
            </ConfigProvider>
          )}
        </DropdownToggle>
        <DropdownMenu
          className={`dropdown-menu-end p-l--xxs ${profileMenuStyle["profile_menu_warapper"]} dropdown__list-item`}
        >
          <div className="">
            <div
              className={` ${profileDrop ? "active" : ""}`}
              onMouseLeave={handleMouseLeaveAll}
            >
              <div
                onClick={handleClickToProfile}
                className="dropdown__item d-flex p-b--xxs"
              >
                <User16 />
                <div>
                  <span className="p-l--xxxs">{user?.displayName} </span>
                </div>
              </div>
              <div>
                <span
                  className="p-l--xxxs p-r--xxxs"
                  style={{
                    display: "inline-block",
                    fontSize: "0.9em",
                    color: "#BBBBBB",
                  }}
                >
                  {`${user?.organization?.code} - ${user?.organization?.name}`}{" "}
                </span>
              </div>
              {/* <div onClick={handleClickToChangePassword} className={`dropdown__item p-b--xxs`}>
                <Repeat16 />
                <span className="p-l--xxxs">
                  {translate("general.actions.changePass")}
                </span>
              </div> */}
              <div
                onClick={handleGetSwitchAccountCode}
                className={`dropdown__item p-b--xxs`}
              >
                <Repeat16 />
                <span className="p-l--xxxs">
                  {translate("general.actions.switchAcc")}
                </span>
              </div>

              <div className={"dropdown__item"} onClick={handleLogout}>
                <Login16 />
                <span className="p-l--xxxs">
                  {translate("general.defaultHeader.logout")}
                </span>
              </div>
            </div>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(ProfileMenu) as any);
